export default __webpack_public_path__ + "static/media/BonnitasFresitasLogo.2c5fb236.png";